import {Component, Input, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {AuthService} from '../../../_services/auth/auth.service';
import {Router} from '@angular/router';
import {Digits} from '../../../_helpers/validators/digits';
import {first} from 'rxjs/operators';
import {loginItem, loginItemList} from '../../../_animations/loginAnimations';

@Component({
  selector: 'app-change-password-form',
  templateUrl: './change-password-form.component.html',
  styleUrls: ['./change-password-form.component.scss', '../../../../loginForm.scss'],
  animations: [loginItemList, loginItem]
})
export class ChangePasswordFormComponent implements OnInit {

  @Input() title: string;

  loading: boolean;
  messageType: string;
  message: string;
  form: FormGroup;

  constructor(private formBuilder: FormBuilder, private auth: AuthService, private router: Router) { }

  ngOnInit(): void {
    this.loading = false;
    this.form = this.formBuilder.group(
      {
        password: ['', [
          Validators.required,
          Validators.minLength(8),
          Digits.digits
        ]],
      }
    );
  }

  createNewPassword() {
    this.loading = true;
    const resetPasswordData = {
      password: this.form.value.password,
    };

    this.auth
      .changePassword(resetPasswordData)
      .pipe(first())
      .subscribe(
        response => {
          this.loading = false;
          if (response.status === 'success') {
            const cu = JSON.parse(localStorage.getItem('currentUser'));
            cu.first_login = false;
            localStorage.setItem('currentUser', JSON.stringify(cu));
            this.router.navigate(['/']);
          } else if (response.status === 'error') {
            this.messageType = 'danger';
            this.message = 'Something went wrong.';
          }
        },
        error => {
          this.loading = false;
        }
      );
  }

}
